import { ProductEntity } from '../entities/ProductEntity';

export type AutoFillInput = {
  entity: ProductEntity | null | undefined;
  quantity: number | '';
  weightKgManuallyEdited: boolean;
  volumeM3ManuallyEdited: boolean;
};

export type AutoFillResult = {
  weightKg?: number;
  volumeM3?: number;
};

const roundTo3Decimals = (value: number): number => Math.round(value * 1000) / 1000;

export const computeAutoFillItemWeightVolume = ({
  entity,
  quantity,
  weightKgManuallyEdited,
  volumeM3ManuallyEdited,
}: AutoFillInput): AutoFillResult => {
  if (!entity) return {};
  // `parseInt('e')` / `parseInt('-')` は NaN を返す。`typeof NaN === 'number'` のため
  // Number.isFinite で NaN / Infinity を弾かないと `weight × NaN = NaN` が書き込まれる。
  if (typeof quantity !== 'number' || !Number.isFinite(quantity) || quantity <= 0) return {};

  const result: AutoFillResult = {};
  if (!weightKgManuallyEdited && entity.weightKgPerUnit != null) {
    result.weightKg = roundTo3Decimals(entity.weightKgPerUnit * quantity);
  }
  if (!volumeM3ManuallyEdited && entity.volumeM3PerUnit != null) {
    result.volumeM3 = roundTo3Decimals(entity.volumeM3PerUnit * quantity);
  }
  return result;
};
